export const RECEIVE_SETTINGS = 'RECEIVE_SETTINGS'
export const RECEIVE_INFO = 'RECEIVE_INFO'
export const CHANGE_ADDRESS = 'CHANGE_ADDRESS'
export const CHANGE_SLOGAN_ADDRESS = 'CHANGE_SLOGAN_ADDRESS'
export const CHANGE_BLOG_VISIBILITY = 'CHANGE_BLOG_VISIBILITY'
export const CHANGE_CUSTOM_DOMAIN = 'CHANGE_CUSTOM_DOMAIN'
export const CHANGE_CUSTOM_DOMAIN_CERT_STATUS = 'CHANGE_CUSTOM_DOMAIN_CERT_STATUS'
export const CHANGE_CUSTOM_DOMAIN_DNS_FAIL= 'CHANGE_CUSTOM_DOMAIN_DNS_FAIL'
export const DELETE_CUSTOM_DOMAIN = 'DELETE_CUSTOM_DOMAIN';
export const RECEIVE_ETC = 'RECEIVE_ETC'
export const CHANGE_USE_COMMENT_RECOGNITION = 'CHANGE_USE_COMMENT_RECOGNITION';
export const CHANGE_ACTIVE_PLUGINS = 'CHANGE_ACTIVE_PLUGINS';
